var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuditNavIcon = function SvgAuditNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M20 2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM3 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M20 7a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zM3 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M20 12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zM3 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M20 17a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zM3 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })));
};
export default SvgAuditNavIcon;